export enum ProcessingStatus {
    PROCESSING = "PROCESSING",
    COMPLETED = "COMPLETED",
    FAILED = "FAILED",
}

export type ManagementZones = {
    id: number;
    name: string;
    is_primary: boolean;
    zones: Zone[];
    custom_properties: string[];
    processing_status: ProcessingStatus;
};

export type Zone = {
    id: number;
    zone_number: number;
    irrigated?: boolean;
    start?: number;
    stop?: number;
    sector?: number;
    treatment?: number;
};
